import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { getTransactionReviewFieldLabel } from "@common/types/transactionFieldReview";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { FieldReviewDetailsRow } from "../fieldReviewDetailsViewConfig";

export const FieldReviewFieldCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, FieldReviewDetailsRow, string>) => {
        const { reviewedField } = row.original;
        return (
            <ViewTableCell>
                {getTransactionReviewFieldLabel(reviewedField)}
            </ViewTableCell>
        );
    },
);

FieldReviewFieldCell.displayName = "FieldReviewFieldCell";
